import { Venue, VenueAdminGetVenueQuery } from '../../graphql/API';
import { venueAdminGetVenue } from '../../graphql/queries';
import { executeGql, processGqlResult } from '../../utils/gql-utils';

export const venueAdminGetVenueApi = async (): Promise<Venue> => {
  const result = await executeGql<VenueAdminGetVenueQuery>(venueAdminGetVenue);
  return processGqlResult<Venue>('venueAdminGetVenue', result);
};
